module.exports = __webpack_public_path__ + "static/media/done.ec6b69be.svg";